import { AudioPlayer } from 'src/com/sixdee/crbtportal/utils/player/audioplayerImpl';

export interface AudioPlayerWithProgress 
{
    startProgress(audioPlayerWithProgressHandler: AudioPlayerWithProgressHandler | undefined): void;
    unRegisterEvents(): void;
}

export interface AudioPlayerWithProgressHandler
{
    updateProgress(percentage: number): void;
    // stopPlay(): void;
}

export class AudioPlayerWithProgressImpl implements AudioPlayerWithProgress 
{
    private audioPlayerWithProgressHandler: AudioPlayerWithProgressHandler | undefined;
    private audio: HTMLMediaElement;

    constructor(audioPlayer: AudioPlayer) 
    {
        this.updateTheTime = this.updateTheTime.bind(this);

        this.audio = audioPlayer.getAudio();

        this.audio.addEventListener('timeupdate', this.updateTheTime, false);
    }

    startProgress(audioPlayerWithProgressHandler: AudioPlayerWithProgressHandler): void 
    {
        if(this.audioPlayerWithProgressHandler !== audioPlayerWithProgressHandler && this.audioPlayerWithProgressHandler !== undefined)
        {
            this.audioPlayerWithProgressHandler.updateProgress(0);
        }
        this.audioPlayerWithProgressHandler = audioPlayerWithProgressHandler;
    }

    updateTheTime() 
    {
        if(this.audioPlayerWithProgressHandler !== undefined)
        {
            let currentPercentage = (this.audio.currentTime / this.audio.duration) * 100;
            this.audioPlayerWithProgressHandler.updateProgress(currentPercentage);
        }
    }

    unRegisterEvents(): void 
    {
        this.audio.removeEventListener('timeupdate', this.updateTheTime, false);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/player/playerwithprogress/playerwithprogressimpl.tsx